
<template>
  <div v-if="isVisible" class="statistics-form a-vs-b--statistics-wrap__total-goals">
    <statistics-oponnents
      :awayTeam="match.AwayTeam"
      :awayTeamLogo="match.AwayTeamLogo"
      :awayTeamShort="match.AwayTeamShort"
      :homeTeam="match.HomeTeam"
      :homeTeamLogo="match.HomeTeamLogo"
      :homeTeamShort="match.HomeTeamShort"
      :componentTitle="componentTitle"
      :componentSubtitle="componentSubtitle"
    />

  <div class="a-vs-b-card-content">
      <div class="a-vs-b-card-content__host">
        <progress-bar
          v-for="(item, index) in contentHost"
          :key="index" :currentData ="item"
          :over="index" />
     </div>
      <div class="a-vs-c--card-divider">
        <span>{{$t('over')}}</span>
        <span>{{$t('under')}}</span>
      </div>
      <div class="a-vs-b-card-content__guest">
        <progress-bar
          v-for="(item, index) in contentGuest"
          :key="index" :currentData ="item"
          :over="index" />
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/soccer/statistics/ProgressBar.vue'

export default {
  components: {
    'progress-bar': ProgressBar
  },
  props: {
    eventData: {
      type: Object,
      required: false
    },
    componentTitle: {
      type: String
    },
    componentSubtitle: {
      type: String
    }
  },
  computed: {
    isVisible: function () {
      return this.match !== undefined && this.match != null
    },
    contentHost: function () {
      let result = []
      if (this.currentMatch) {
        result.push(this.currentMatch.HomeTotalGoalsOver1)
        result.push(this.currentMatch.HomeTotalGoalsOver2)
        result.push(this.currentMatch.HomeTotalGoalsOver3)
        result.push(this.currentMatch.HomeTotalGoalsOver4)
      }
      return result
    },
    contentGuest: function () {
      let result = []
      if (this.currentMatch) {
        result.push(this.currentMatch.AwayTotalGoalsOver1)
        result.push(this.currentMatch.AwayTotalGoalsOver2)
        result.push(this.currentMatch.AwayTotalGoalsOver3)
        result.push(this.currentMatch.AwayTotalGoalsOver4)
      }
      return result
    },
    match: function () {
      if (this.eventData != null) {
        return this.eventData.Matches[0]
      } else {
        return null
      }
    },
    currentMatch: function () {
      if (this.eventData != null) {
        return this.eventData.Matches[0].Stats.TotalGoals
      } else {
        return null
      }
    }

  }
}
</script>
